import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CollapseButton, Feedbacks, StickyHeadings, Subheading } from '@datacamp/le-shared-components';
import React from 'react';
import { withTranslation } from 'react-i18next';
import MarkdownContent, { converter } from './MarkdownContent';
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultProps = {};
class LeftPanel extends React.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      currentFeedbackIndex: this.props.feedbackMessages.length - 1
    });
    _defineProperty(this, "feedbacksRef", React.createRef());
    _defineProperty(this, "componentDidUpdate", prevProps => {
      const {
        feedbackMessages
      } = this.props;
      if (prevProps.feedbackMessages.length !== feedbackMessages.length) {
        const element = this.feedbacksRef.current;
        if (element !== null) {
          element.focus();
        }
        this.setState({
          currentFeedbackIndex: feedbackMessages.length - 1
        });
      }
    });
  }
  render() {
    const {
      assignment,
      children,
      feedbackMessages,
      hintCost,
      onClickCollapse,
      onTakeHint,
      onTakeSolution,
      solutionShown,
      t,
      title,
      xp
    } = this.props;
    const {
      currentFeedbackIndex
    } = this.state;
    const hintShown = feedbackMessages.findIndex(_ref => {
      let {
        messageType
      } = _ref;
      return messageType === 'HINT';
    }) !== -1;
    const hintAndSolutionButtonProps = hintShown ? {
      isSolution: true,
      isVisible: onTakeSolution !== undefined && !solutionShown,
      onClick: onTakeSolution,
      xp
    } : {
      isSolution: false,
      isVisible: true,
      onClick: onTakeHint,
      xp: hintCost
    };
    const extendedFeedbackMessages = feedbackMessages.map((feedbackMessage, feedbackMessageIndex) => {
      var _feedbackMessage$body;
      return _objectSpread(_objectSpread({}, feedbackMessage), {}, {
        body: converter.makeHtml((_feedbackMessage$body = feedbackMessage.body) !== null && _feedbackMessage$body !== void 0 ? _feedbackMessage$body : ''),
        isActive: feedbackMessageIndex === currentFeedbackIndex,
        rating: feedbackMessage.rating
      });
    });
    return ___EmotionJSX("section", {
      className: "dc-panel dc-u-h-100pc exercise__sidebar",
      "data-cy": "left-panel"
    }, ___EmotionJSX(StickyHeadings, {
      items: [{
        content: ___EmotionJSX("div", {
          className: "dc-panel__body"
        }, ___EmotionJSX("h4", null, title), ___EmotionJSX(MarkdownContent, {
          markdown: assignment
        })),
        header: ___EmotionJSX(Subheading, {
          iconName: "assignment"
        }, t('exercise', {
          count: 1,
          ns: 'glossary'
        })),
        key: 'assignment'
      }, {
        content: ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
          className: "dc-panel__body"
        }, children), ___EmotionJSX(Feedbacks, {
          feedbackMessages: extendedFeedbackMessages,
          hintAndSolution: hintAndSolutionButtonProps,
          innerRef: this.feedbacksRef,
          key: "".concat(title, "_").concat(hintShown),
          onClickTab: index => this.setState({
            currentFeedbackIndex: index
          })
        })),
        header: ___EmotionJSX(Subheading, {
          iconName: "checkmark_circle",
          tagContent: "".concat(xp, "XP")
        }, t('instruction', {
          count: 2,
          ns: 'glossary'
        })),
        key: 'instructions'
      }]
    }), ___EmotionJSX(CollapseButton, {
      direction: "left",
      onClick: onClickCollapse,
      style: {
        right: '0',
        top: '0'
      }
    }));
  }
}
_defineProperty(LeftPanel, "defaultProps", defaultProps);
export default withTranslation()(LeftPanel);